import React, { useMemo } from 'react'
import { Box } from '@chakra-ui/react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { Header } from './components/Header'
import { PatternProvider } from './context/PatternContext'

export function PatternLayout() {
  const navigate = useNavigate()
  const location = useLocation()

  // Determinar qual tab está ativa com base na rota atual
  const currentTab = useMemo(() => {
    const path = location.pathname

    if (path.includes('/pattern/generate-images') || path.includes('/pattern/final-selection')) {
      return { id: 'novaArte', label: 'Nova Arte' }
    } else if (path.includes('/pattern/biblioteca')) {
      return { id: 'bibliotecaArtes', label: 'Biblioteca de Artes' }
    } else {
      return { id: 'novaArte', label: 'Nova Arte' }
    }
  }, [location.pathname])

  const tabs = useMemo(
    () => [
      { id: 'novaArte', label: 'Nova Arte' },
      { id: 'bibliotecaArtes', label: 'Biblioteca de Artes' },
    ],
    []
  )

  // Função para mudar de tab via navegação
  const handleTabChange = (tab) => {
    if (tab.id === 'novaArte') {
      navigate('/pattern')
    } else if (tab.id === 'bibliotecaArtes') {
      navigate('/pattern/biblioteca')
    }
  }

  return (
    <PatternProvider>
      <Header tabs={tabs} currentTab={currentTab} onTabChange={handleTabChange} />
      <Box pt={0} px={4}>
        <Outlet />
      </Box>
    </PatternProvider>
  )
}
